import { useEffect } from 'react'

import {
  ImagePreview,
  useImagePreview
} from 'src/providers/ImagePreviewProvider'

import { Image } from 'src/components/atoms/Image'
import { Heading5, Paragraph } from 'src/components/atoms/Typography/Typography'

import { MappedPhotos, photosForPreview } from 'src/utils/assets'

export type PlantingPhotosProps = {
  photos: MappedPhotos | undefined
}

export const PlantingPhotos = ({ photos }: PlantingPhotosProps) => {
  const { setImageUrls, show } = useImagePreview()

  useEffect(() => {
    if (photos) {
      setImageUrls(photosForPreview(photos))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photos])

  if (!photos) return null

  if (
    !photos.cover &&
    !photos.project?.length &&
    !photos.monitorings?.length &&
    !photos.plantings?.some(p => p.photos.length)
  ) {
    return (
      <div>
        <Paragraph>
          No photos have been uploaded for this planting and monitoring records
        </Paragraph>
      </div>
    )
  }

  return (
    <div className='flex flex-col gap-5'>
      {photos.cover ? (
        <div>
          <Heading5 className='mb-5'>Project cover photo</Heading5>
          <div className='grid gap-5 grid-cols-2 lg:grid-cols-4'>
            <div>
              <Image
                alt='Project cover photo'
                src={photos.cover}
                width={270}
                height={200}
                className='object-cover cursor-pointer'
                onClick={() => show(photos.cover)}
              />
            </div>
          </div>
        </div>
      ) : null}
      {photos.project?.length ? (
        <div>
          <Heading5 className='mb-5'>Project photos</Heading5>
          <div className='grid gap-5 grid-cols-2 lg:grid-cols-4'>
            {photos.project?.map(photo => (
              <div key={photo?.Uri}>
                <Image
                  alt={`Thumbnail for file: ${photo?.name}`}
                  src={photo?.Uri!}
                  width={270}
                  height={200}
                  className='object-cover cursor-pointer'
                  onClick={() => show(photo?.Uri)}
                  type={photo?.type}
                />
              </div>
            ))}
          </div>
        </div>
      ) : null}
      {photos.plantings?.length ? (
        <div>
          <Heading5 className='mb-5'>From planting report</Heading5>
          <div className='grid gap-5 grid-cols-2 lg:grid-cols-4'>
            {photos.plantings?.map(p =>
              p.photos.map(photo => (
                <div key={photo?.Uri}>
                  <Image
                    alt={`Thumbnail for file: ${photo?.name}`}
                    src={photo?.Uri!}
                    width={270}
                    height={200}
                    className='object-cover cursor-pointer'
                    onClick={() => show(photo?.Uri)}
                    type={photo?.type}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      ) : null}
      {photos.monitorings?.map(monitoring => {
        return (
          <div key={`Monitoring ${monitoring.title}`}>
            <Heading5 className='mb-5'>
              Monitoring event {monitoring.title}
            </Heading5>
            <div className='grid gap-5 grid-cols-2 lg:grid-cols-4'>
              {monitoring.photos.map(photo => {
                return (
                  <div key={photo?.Uri}>
                    <Image
                      alt={`Thumbnail for file: ${photo?.name}`}
                      src={photo?.Uri!}
                      width={270}
                      height={200}
                      className='object-cover cursor-pointer'
                      onClick={() => show(photo?.Uri)}
                      type={photo?.type}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
      <ImagePreview />
    </div>
  )
}
